
<ngx-spinner 
  bdColor = "rgba(0, 0, 0, 0.8)" 
  size = "medium" 
  color = "#fff" 
  type = "line-spin-clockwise-fade" 
  [fullScreen] = "true"
>
  <p style="color: white" > {{ 'LOADING' | translate }}... </p>
</ngx-spinner>

<h1 mat-dialog-title>{{ 'IMAGEVIEWER' | translate }}</h1>
<mat-dialog-content>
    <img [src]="data.images.dataUrl" [alt]="data.images.fileName" style="border: 1px solid #ddd; border-radius: 4px; padding: 5px; max-width: 700px; max-height: 265px;" />
    <p>{{ data.images.fileName }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="background-color: #6c757d; color: white;" (click)="closeModal()">{{ 'CLOSE' | translate }}</button>
</mat-dialog-actions>
